/**
 * 类目
 *
 * @export
 * @enum {number}
 */
export enum EnumMedicineCategory {
  '中药' = 'TCM',
  '中成药' = 'CPM',
}

/**
 * 药品类型
 *
 * @export
 * @enum {number}
 */
export enum EnumMedicineType {
  '草药' = 0,
  '颗粒' = 1,
  '超微' = 2,
  '中成药' = 10,
  '粉剂' = 20,
  '散剂' = 21,
  '膏方' = 30,
  '浓缩膏' = 31,
  '蜜丸' = 40,
  '水丸' = 41,
  '浓缩丸' = 42,
  '胶囊' = 50,
}

/**
 * 自定义控件展示类型
 *
 * @export
 * @enum {number}
 */
export enum EnumCustomControl {
  'BUTTON' = 'BUTTON',
  'A' = 'A',
}


/** 药品信息中的类型 */
export enum EnumMedicineInfoCategory {
  中药 = 1,
  中成药 = 2,
  西药 = 3,
  西成药 = 4,
}

/** 中成药药品类型选择 */
export const MedicineInfoCategory = [
  { value: EnumMedicineInfoCategory.中成药, label: '中成药' },
  { value: EnumMedicineInfoCategory.西药, label: '西药' },
]



/** 疾病类型，例如ICD9, ICD10（PC端同步枚举） */
export enum EnumDiseaseType {
  /** 脉景标准 */
  STD = 0,
  /** @deprecated */
  ICD9 = 1,
  /** @deprecated */
  ICD10 = 2,
  /** ICD10 version 2019 */
  ICD10_2019 = 3,
  /** GB中医 */
  GB = 4,
}

export enum SymptomType {
  Unknown = 0,
  Subjective = 1,
  Objective = 2,
  PartRemark = 3,
  SymptomRemark = 4,
  CompoundWord = 5
}


// WEBPACK FOOTER //
// ./src/constants/enum.ts